import React, {Component} from 'react'
import {Form, Select} from 'antd';

export default class SelectShift extends Component {
    constructor(props) {
        super(props)
    }

    componentWillReceiveProps(nextProps) {
        const flag = nextProps.data && Array.isArray(nextProps.data) && nextProps.data.length > 0;
        return flag
    }

    render() {
        let options = [];
        if (this.props.data != null) {
            this.props.data.forEach(
                d => {
                    options.push(<Select.Option key={d.id}
                                                value={d.shiftDt}>{d.shiftDt}</Select.Option>)
                })
        }
        return <Form.Item label={this.props.label}>
            {this.props.getFieldDecorator(this.props.name, {
                initialValue: this.props.initialValue,
                rules: [{required: true, message: '该项必填'}]
            })(<Select onChange={this.props.handleChange}
                       getPopupContainer={triggerNode => triggerNode.parentNode}
                       disabled={this.props.disabledOpt}>
                {options}
            </Select>)}
        </Form.Item>
    };
}
